import styles from './FeatureItem.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import { Card, ICardProps } from 'components/Card/Card';
import { TextStack } from 'components/TextStack/TextStack';
import { isEntry } from 'utils/EntryUtil';

export const FeatureItem: FC<ICardProps> = ({ entry, tabIndex, className, ...props }) => {
  if (!isEntry(entry)) return null;

  return (
    <div className={cx(styles.featureItem, className)}>
      <Card
        entry={entry}
        mediaClassName={styles.imageWrapper}
        captionClassName={styles.carouselCardCaption}
        className={styles.carouselCard}
        mediaProps={{ imageWidth: 1.05 }}
        {...props}
      >
        <TextStack
          entry={entry}
          titleTagName="h3"
          linkClassName={cx(styles.carouselItemLink, 'item-link')}
          blurbClassName={styles.carouselItemText}
          className={styles.carouselItemContent}
          tabIndex={tabIndex}
          showLinkArrow
        />
      </Card>
    </div>
  );
};
